import { Link, useMatch, useResolvedPath } from "react-router-dom";

export default function AdmMenu({ children, icon, to }: any) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: false });

  return (
    <div
      className={`border-r${
        match ? " border-automark-dark bg-gray-50" : "border-gray-50"
      }`}
    >
      <Link to={to}>
        <div className="py-3 px-6 flex items-center text-gray-600">
          <div className="">{icon}</div>
          <div className="ml-2 hidden sm:block">{children}</div>
        </div>
      </Link>
    </div>
  );
}
